import { ICoreState } from '@core/models';
import { createReducer, on } from '@ngrx/store';
import { setShowSidebar, setToggleSidebar } from '@store/actions/core.actions';

export const coreInitialState: ICoreState = {
  showSidebar: true,
};

export const coreReducer = createReducer(
  coreInitialState,
  on(setShowSidebar, (state, { value }): ICoreState => ({ ...state, showSidebar: value })),
  on(setToggleSidebar, (state): ICoreState => ({ ...state, showSidebar: !state.showSidebar }))
);
